import { userManager } from '~/utility/BinSentry-ui-utility';
import { LitElement, html } from '~/lib/bn-lit-element';
import { sharedStyles } from '../styles/shared-styles';
import { sessionStyles } from '../styles/session-styles';
import '../common/bn-logo';

class LogoutRedirectPage extends LitElement {
  static get properties() {
    return {
      error: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, sessionStyles];
  }

  render() {
    return html`
      <div class="boxes">
        <div class="box">
          <bn-logo></bn-logo>
          <p>
            You have been successfully signed out.
          </p>
          <p>
            <a href="/login">Return to sign-in</a>
          </p>
        </div>
      </div>
    `;
  }

  connectedCallback() {
    super.connectedCallback();

    // we don't care enough about failure modes on the cognito signout to annoy the user about it
    userManager.signoutRedirectCallback().then(/* nothing */);
  }
}

window.customElements.define('logout-redirect-page', LogoutRedirectPage);
